// frontend/src/components/settings/JoinClassroomCard.tsx

import { useState } from 'react';
import { authService } from '../../services/auth.service';

const API_BASE = (import.meta.env.PROD && (import.meta.env.VITE_API_BASE_URL === 'http://localhost:8080' || !import.meta.env.VITE_API_BASE_URL)) ? '' : (import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080');

export function JoinClassroomCard() {
  const [code, setCode] = useState('');
  const [message, setMessage] = useState<{ text: string; type: 'success' | 'error' } | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  async function handleJoin() {
    if (!code.trim()) return;
    setIsLoading(true);
    setMessage(null);
    try {
      const token = await authService.getAccessToken();
      const res = await fetch(`${API_BASE}/api/teacher/join`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ code: code.trim() }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error?.message || 'Katılım başarısız.');
      setMessage({ text: 'Sınıfa katıldın! 🎉', type: 'success' });
      setCode('');
    } catch (err) {
      setMessage({ text: err instanceof Error ? err.message : 'Hata oluştu.', type: 'error' });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="card" style={{ marginTop: 24 }}>
      <h3 className="parent-section-title">Sınıfa Katıl</h3>
      <div style={{ display: 'flex', gap: 8 }}>
        <input className="input" placeholder="Öğretmen kodu" value={code} onChange={(e) => setCode(e.target.value)} style={{ flex: 1 }} />
        <button type="button" className="lesson-btn primary sm" onClick={handleJoin} disabled={isLoading}>
          {isLoading ? '...' : 'Katıl'}
        </button>
      </div>
      {message && <p className={message.type === 'success' ? 'auth-info' : 'auth-error'} style={{ marginTop: 8 }}>{message.text}</p>}
    </div>
  );
}
